import React from 'react';

import { Body } from '@grnhse/seedling/lib/birch/typography';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { Label } from '@grnhse/seedling/lib/birch/typography';

import { withLocalePrefix } from 'shared/utils/translation';
import { SignalListList, SignalItem } from 'fraud/components/fraud_signals';
import { ResolvedReason } from 'fraud/types';

const t = withLocalePrefix('fraud');

const FraudResolvedSignalsInfo = ({
  dismissedBy,
  signalCount,
  date,
  resolvedReasons,
}: {
  dismissedBy: string | null;
  signalCount: number;
  date: string | null;
  resolvedReasons?: ResolvedReason[];
}) => {
  if (!date || !dismissedBy) {
    return null;
  }

  return (
    <Stack spacing={1} data-provides="fraud-resolved-signals-info">
      <Body>
        {signalCount === 1
          ? t('fraud_report.signals.resolved_by', {
              user: dismissedBy,
              count: signalCount,
              date: date,
            })
          : t('fraud_report.signals.resolved_by_plural', {
              user: dismissedBy,
              count: signalCount,
              date: date,
            })}
      </Body>
      <Label>{t('fraud_report.signals.resolved_reasons_provided')}</Label>
      {resolvedReasons && (
        <SignalListList>
          {resolvedReasons.map((reason) => {
            return (
              <SignalItem key={reason.id}>
                <Body>{`${t(
                  `resolve_fraud_report_modal.resolved_reason_types.${reason.name}`
                )} ${reason.other ? `- ${reason.other}` : ''}`}</Body>
              </SignalItem>
            );
          })}
        </SignalListList>
      )}
    </Stack>
  );
};

export default FraudResolvedSignalsInfo;
